
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic09 as ObiHydraulic09Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-09.js';
 
 
 

 
 export const ObiHydraulic09 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-09',
   elementClass: ObiHydraulic09Element,
   events: {
     
   }
  });
 
 